import React from 'react';
import { Box, Container, Typography, Grid, Card } from '@mui/material';
import { styled } from '@mui/material/styles';
import NavBar from './shared/NavBar';
import Footer from './shared/Footer';

const TeamMemberCard = styled(Card)(({ theme }) => ({
  height: '100%',
  padding: theme.spacing(4),
  textAlign: 'center',
  background: 'linear-gradient(135deg, #FFF8F3 0%, #FFF 100%)',
  borderRadius: '16px',
  border: '1px solid rgba(255,107,53,0.08)',
  transition: 'all 0.3s ease',
  '&:hover': {
    transform: 'translateY(-4px)',
    boxShadow: '0 8px 24px rgba(255,107,53,0.15)',
  }
}));

const AboutUs = () => {

  return (
    <Box>
      <NavBar />
      <Container>
        <Box sx={{ py: 8 }}>


          <Grid container spacing={4} sx={{ mb: 8 }}>
            <Grid item xs={12} md={6}>
              <Box sx={{ 
                height: '100%', 
                display: 'flex', 
                flexDirection: 'column', 
                justifyContent: 'center' 
              }}>
                <Typography variant="h4" gutterBottom sx={{ color: '#FF6B35', fontWeight: 'bold' }}>
                  Our Mission
                </Typography>
                <Typography variant="body1" paragraph sx={{ fontSize: '1.1rem', color: '#666' }}>
                  At YoungPresso, we believe that staying informed should be engaging and educational. 
                  Our mission is to make news accessible and interesting for young minds, helping them 
                  become well-informed global citizens.
                </Typography>
                <Typography variant="body1" sx={{ fontSize: '1.1rem', color: '#666' }}>
                  We curate and simplify news content, making it age-appropriate while maintaining 
                  its educational value. Through interactive features and rewards, we make learning 
                  about current events an enjoyable experience.
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box sx={{ 
                width: '100%',
                height: '400px',
                borderRadius: '24px',
                overflow: 'hidden',
                boxShadow: '0 8px 24px rgba(255,107,53,0.15)'
              }}>
                <img 
                  src="https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=1200&h=800&fit=crop"
                  alt="Our Mission"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover'
                  }}
                />
              </Box>
            </Grid>
          </Grid>


        </Box>
      </Container>
      <Footer />
    </Box>
  );
};

export default AboutUs;
